/* eslint-disable react/destructuring-assignment */
import { Box, Grid, Tooltip } from '@material-ui/core';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import clsx from 'clsx';
import { LinkComp } from 'components/atoms';
import { BRAND_NAME } from 'constants/Enums';
import { getHardcodeStoreByTagList } from 'constants/flagship-store';
import { COLOR_STORE } from 'constants/Icons';
import { useSetting } from 'context';
import { useTranslation } from 'next-i18next';
import { memo } from 'react';
import { ImageFallbackStatic } from 'utils/ImageFallback';
import useMobileV2 from 'zustand-lib/storeMobile';
import styles from './styles.module.css';
/*
 Internal Seller: 
- Có Hóa Đơn => "MedX"
- Không hóa đơn => Không hiện thị
External Seller:
- Doanh nghiệp => hiện tên doanh nghiệp
- Cá nhân => "Đối tác của thuocsi"



*/
const SellerInfo = (props) => {
  const { t: translateCommon } = useTranslation('common');

  // const partnerName = translateCommon('partner_of_buymed').replace('{BRAND_NAME}', BRAND_NAME);
  // const getSellerByCode = useSellers((state) => state.getSellerByCode);
  const isMobileV2 = useMobileV2((state) => state.isMobileV2());

  // gọi tới cache chung lấy seller map
  const {
    seller = {},
    tags = [],
    isProductCard = false,
    isWishlist = false,
    isChat = false,
    containerClass,
    isWebView = false,
  } = props;
  const { code } = seller;

  const { mapStoreActives = new Map(), getNameSeller } = useSetting();
  const { fullNameSeller, isDisplayStore, linkSeller, linkStore, tcode } = getNameSeller({
    seller,
    tags,
  });

  const displayName =
    tcode !== 'seller'
      ? translateCommon(`seller.${tcode}`).replace('{BRAND_NAME}', BRAND_NAME)
      : fullNameSeller;

  // const isActiveStore = mapStoreActives?.get(code) || null;
  // hiển thị với seller là doanh nghiệp ngoài

  // hard code store
  const flagshipStore = getHardcodeStoreByTagList(tags);

  if (flagshipStore) {
    return (
      <Grid
        className={clsx(
          styles.supplierTitle,
          containerClass,
          {
            [styles.supplierTitle_mv2]: isMobileV2,
          },
          isChat && styles.m0,
        )}
        item
        xs={12}
        container
        justifyContent="flex-start"
        direction="row"
      >
        <Tooltip disableTouchListener={isMobileV2} title={flagshipStore.name}>
          <Grid
            className={isWishlist ? styles.supplier_title_v2 : styles.name}
            item
            xs={12}
            container
            justifyContent="flex-start"
            direction="row"
          >
            {!isProductCard ? (
              <strong>{translateCommon('provided_by')}: </strong>
            ) : (
              <ImageFallbackStatic
                width="14"
                height="16"
                src={COLOR_STORE}
                alt={flagshipStore.name}
                className={styles.image_logo}
              />
            )}
            <>
              {isWebView ? (
                <Box
                  className={clsx(
                    styles.link,
                    {
                      [styles.link_mv2]: isMobileV2,
                    },
                    isWishlist && styles.supplier_title_v2,
                    isChat && styles.sellerProduct,
                  )}
                  stopProp
                  style={{ fontSize: !isChat && 12 }}
                >
                  {flagshipStore.name}
                </Box>
              ) : (
                <LinkComp
                  target="_blank"
                  className={clsx(
                    styles.link,
                    {
                      [styles.link_mv2]: isMobileV2,
                    },
                    isWishlist && styles.supplier_title_v2,
                    isChat && styles.sellerProduct,
                  )}
                  stopProp
                  style={{ fontSize: !isChat && 12 }}
                  href={flagshipStore.url}
                >
                  {flagshipStore.name}
                </LinkComp>
              )}
            </>
          </Grid>
        </Tooltip>
      </Grid>
    );
  }

  return (
    <Grid
      className={clsx(
        styles.supplierTitle,
        {
          [styles.supplierTitle_mv2]: isMobileV2,
        },
        isChat && styles.m0,
      )}
      item
      xs={12}
      container
      justifyContent="flex-start"
      direction="row"
      // style={{ display: 'none' }}
    >
      {displayName && (
        <Tooltip disableTouchListener={isMobileV2} title={displayName}>
          <Grid
            className={isWishlist ? styles.supplier_title_v2 : styles.name}
            item
            xs={12}
            container
            justifyContent="flex-start"
            direction="row"
          >
            {!isProductCard ? (
              <strong>{translateCommon('provided_by')}: </strong>
            ) : (
              <ImageFallbackStatic
                width="14"
                height="16"
                src={COLOR_STORE}
                alt={displayName}
                className={styles.image_logo}
              />
            )}
            {mapStoreActives?.get(code) ? (
              <>
                {isWebView ? (
                  <Box
                    stopProp
                    className={clsx(
                      styles.link,
                      {
                        [styles.link_mv2]: isMobileV2,
                      },
                      isWishlist && styles.supplier_title_v2,
                      isChat && styles.sellerProduct,
                    )}
                  >
                    {displayName}
                    {!isProductCard && (
                      <Tooltip title={translateCommon('view_store')}>
                        <OpenInNewIcon
                          style={{ color: '#676F77', paddingTop: '10px', marginBottom: '-3px' }}
                        />
                      </Tooltip>
                    )}
                  </Box>
                ) : (
                  <LinkComp
                    stopProp
                    target="_blank"
                    className={clsx(
                      styles.link,
                      {
                        [styles.link_mv2]: isMobileV2,
                      },
                      isWishlist && styles.supplier_title_v2,
                      isChat && styles.sellerProduct,
                    )}
                    href={linkStore}
                  >
                    {displayName}
                    {!isProductCard && (
                      <Tooltip title={translateCommon('view_store')}>
                        <OpenInNewIcon
                          style={{ color: '#676F77', paddingTop: '10px', marginBottom: '-3px' }}
                        />
                      </Tooltip>
                    )}
                  </LinkComp>
                )}
              </>
            ) : (
              <>
                {isDisplayStore ? (
                  <>
                    {isWebView ? (
                      <Box
                        stopProp
                        className={clsx(
                          styles.link,
                          {
                            [styles.link_mv2]: isMobileV2,
                          },
                          isWishlist && styles.supplier_title_v2,
                          isChat && styles.sellerProduct,
                        )}
                      >
                        {displayName}
                      </Box>
                    ) : (
                      <LinkComp
                        stopProp
                        target="_blank"
                        className={clsx(
                          styles.link,
                          {
                            [styles.link_mv2]: isMobileV2,
                          },
                          isWishlist && styles.supplier_title_v2,
                          isChat && styles.sellerProduct,
                        )}
                        href={linkSeller}
                      >
                        {displayName}
                      </LinkComp>
                    )}
                  </>
                ) : (
                  <>
                    {isWebView ? (
                      <Box
                        stopProp
                        className={clsx(
                          styles.link,
                          {
                            [styles.link_mv2]: isMobileV2,
                          },
                          isWishlist && styles.supplier_title_v2,
                          tcode === 'seller_partner' && styles.text_tf_none,
                          isChat && styles.sellerProduct,
                        )}
                      >
                        {displayName}
                      </Box>
                    ) : (
                      <LinkComp
                        stopProp
                        target="_blank"
                        className={clsx(
                          styles.link,
                          {
                            [styles.link_mv2]: isMobileV2,
                          },
                          isWishlist && styles.supplier_title_v2,
                          tcode === 'seller_partner' && styles.text_tf_none,
                          isChat && styles.sellerProduct,
                        )}
                        href={linkSeller}
                      >
                        {displayName}
                      </LinkComp>
                    )}
                  </>
                  // <span
                  //   className={clsx(
                  //     styles.link,
                  //     {
                  //       [styles.link_mv2]: isMobileV2,
                  //     },
                  //     isWishlist && styles.supplier_title_v2,
                  //   )}
                  // >
                  //   {sellerName}
                  // </span>
                )}
              </>
            )}
          </Grid>
        </Tooltip>
      )}
    </Grid>
  );
};

export default memo(SellerInfo);
